import { DetailConfigType, DetailPage } from '../types';
import * as detailConfigList from '../config';

export function dealwithConfig(params: DetailPage) {
  const { key, filter, extraConfig, titleCn } = params || {};
  let { title, defaultProps = {}, detailPageOptions = {} } = params || {};
  const {
    title: detailTitle,
    defaultProps: detailDefaultProps = {},
    detailPageOptions: detailPageOptionsProps = {},
    ...detailConfig
  }: DetailConfigType = (detailConfigList as any)[key] || {};

  // 标题
  title = title || detailTitle;

  // 图表的属性
  defaultProps = Object.assign({ filter }, detailDefaultProps, defaultProps);

  // 详情页的属性
  detailPageOptions = { ...detailPageOptionsProps, ...detailPageOptions };

  return {
    title,
    filter,
    defaultProps,
    detailFilter: extraConfig,
    detailPageOptions,
    titleCn,
    ...detailConfig,
  };
}
